import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { Grid, Row, Col } from 'react-bootstrap';
import { Navbar } from 'js/portfolio/components/navbar';
import { Visible } from 'js/portfolio/components/visible';
import Home from './home';
import Header from './header';
import Research from './research';
import CV from './cv';
import Contact from './contact';
import PreviewHeader from './preview_header';

// this is the first step towards seperating css from academia-app.
// dev only for now.
import 'app/assets/stylesheets/portfolio/libraries.scss';
import 'app/assets/stylesheets/portfolio/custom.scss';

export class Portfolio extends Component {
  getChildContext() {
    return { viewMode: this.props.viewMode };
  }

  render() {
    return (
      <div>
        <Visible modes={(m) => m > 0}>
          <PreviewHeader
            providedPicture={this.props.providedPicture}
            appliesTimePressure={
              this.props.isFromCompletingPlfFirstTime &&
              this.props.viewMode === 3
            }
          />
        </Visible>
        <Grid fluid className="Portfolio">
          <Col>
            <Header
              isDirectlyFromPremiumFunnel={
                this.props.isDirectlyFromPremiumFunnel
              }
            />
          </Col>

          <Row>
            <Col xs={10} xsOffset={1} md={6} mdOffset={3}>
              <Navbar />
              <Route exact path="/" component={Home} />
              <Route path="/home" render={() => <Redirect to="/" />} />
              <Route path="/cv" component={CV} />
            </Col>
          </Row>

          <Route path="/research" component={Research} />
          <Route path="/contact" component={Contact} />
        </Grid>
      </div>
    );
  }
}

Portfolio.childContextTypes = {
  viewMode: PropTypes.number.isRequired,
  isDirectlyFromPremiumFunnel: PropTypes.bool,
};

export default Portfolio;
